'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Static2 = require('./Static');

var _Static3 = _interopRequireDefault(_Static2);

exports.Static = _Static3['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/FormControls/index.js
 ** module id = 559
 ** module chunks = 0
 **/